import { render, staticRenderFns } from "./ValidateGroupComponent.vue?vue&type=template&id=09391b8d"
import script from "./ValidateGroupComponent.vue?vue&type=script&lang=ts"
export * from "./ValidateGroupComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-load_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports